export const gtm = 'GTM-KWWQGV76'

// デバック用
// export const gtm = 'GTM-WVXH3X7T'

export const homeDir = '/shoplist/sasui/ochashindan/'

export const meta = {
  title: 'ブレンドティー診断 | 伊藤園',
  description: {
    top: 'ようこそ、五感で楽しむ日本茶の世界へ。sasuiのブレンドティー診断で、気分やライフスタイルに合わせたぴったりの一杯をご提案します。',
    result:
      'あなただけの一杯に出会える、sasuiブレンドティー診断の結果ページです。その味わいや香りとともに、今のあなたに似合うお茶をご紹介します。',
  },
}
